import type { CardTemplateResponseDto } from '@lunary/api-client'
import { DAILY_TEXT_FIELDS, sameCardText } from '@lunary/ui-web/card-text'

export type CardText = CardTemplateResponseDto

export const EMPTY_TEXT: CardText = { headline: '', body: '', attention: '', advice: '', question: '' }

export function sameText(a: CardText, b: CardText): boolean {
  return sameCardText(DAILY_TEXT_FIELDS, a, b)
}

export function textOf(source: Partial<CardText> | null | undefined): CardText {
  return {
    headline: source?.headline ?? '',
    body: source?.body ?? '',
    attention: source?.attention ?? '',
    advice: source?.advice ?? '',
    question: source?.question ?? '',
  }
}
